import { IMAGES } from "../../constants/contact";

const sectors = [
  {
    title: "Ristorazione & Accoglienza",
    text: "Gestione comande al tavolo, divisione conti rapida e POS senza canone nei mesi di chiusura per le attività stagionali.",
    img: IMAGES.settoreA,
    alt: "Terminale POS in un locale di ristorazione",
    testid: "sector-ristorazione",
  },
  {
    title: "Commercio & Professionisti",
    text: "Incassi veloci al banco, ricevute istantanee via SMS e accredito diretto sul tuo conto corrente senza cambiare banca.",
    img: IMAGES.settoreB,
    alt: "Pagamento contactless in un negozio artigianale",
    testid: "sector-commercio",
  },
];

export function Settori() {
  return (
    <section id="attivita" data-testid="settori-section" className="py-24 bg-[#ECEAE4] px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16">
          <div>
            <span className="font-sans text-xs uppercase tracking-widest text-[#1B4D3E] font-bold">
              Settori Specifici
            </span>
            <h2 className="text-3xl md:text-5xl font-normal text-[#1B4D3E] mt-2">
              Soluzioni adatte alla tua realtà.
            </h2>
          </div>
          <p className="font-sans text-sm text-[#5A564F] max-w-sm mt-4 md:mt-0">
            Dalla cassa veloce al tavolo, configuriamo l'hardware ideale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {sectors.map((s) => (
            <div key={s.title} data-testid={s.testid} className="bg-white p-8 border border-[#DFDCD4]">
              <div className="aspect-[16/9] mb-6 relative overflow-hidden frame-drift">
                <img src={s.img} alt={s.alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              </div>
              <h3 className="text-2xl font-normal text-[#1B4D3E] mb-2">{s.title}</h3>
              <p className="font-sans text-sm text-[#5A564F] leading-relaxed mb-4">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
